import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';

import { registerSocketResync } from '../api/config';
import socketMiddleware from './middlewares/socketMiddleware';
import rootReducer from './reducers';
import messagesActions from './actions/messages';
import { getCurrentDialogId } from './selectors';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = [thunk, socketMiddleware()];

// replace with redux toolkit
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));

registerSocketResync(() => {
  const dialogId = getCurrentDialogId(store.getState());
  if (dialogId) {
    store.dispatch(messagesActions.resyncMessages(dialogId));
  }
});

export default store;
